// tenant_suspended_modal_v1: full-screen block for suspended/inactive tenants
import React, { useState, useEffect } from 'react';
import { Phone, XCircle } from 'lucide-react';

export default function SuspendedScreen() {
  const [reason, setReason] = useState(null); // null | 'suspended' | 'inactive' | 'not_found'

  useEffect(() => {
    // Check on mount (in case interceptor fired before listener attached)
    if (typeof window !== 'undefined' && window.__tenantBlockReason) {
      setReason(window.__tenantBlockReason);
    }

    // Listen for future events
    const handler = (e) => {
      setReason(e.detail?.reason || 'suspended');
    };
    window.addEventListener('tenant-blocked', handler);
    return () => window.removeEventListener('tenant-blocked', handler);
  }, []);

  if (!reason) return null;

  // Map reason → display text
  const titles = {
    suspended: 'บัญชีของท่านถูกระงับ',
    inactive: 'บัญชีไม่ได้เปิดใช้งาน',
    not_found: 'ไม่พบบัญชี',
  };
  const subtitles = {
    suspended: 'บัญชีของท่านถูกระงับการใช้งานในขณะนี้',
    inactive: 'บัญชีของท่านยังไม่ได้เปิดใช้งาน',
    not_found: 'ไม่พบบัญชีของท่านในระบบ',
  };
  const title = titles[reason] || titles.suspended;
  const subtitle = subtitles[reason] || subtitles.suspended;

  const logout = () => {
    try { localStorage.clear(); } catch (e) {}
    window.location.href = '/login';
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: 'rgba(15, 23, 42, 0.96)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{
        maxWidth: 480, width: '100%',
        background: '#fff', borderRadius: 18,
        padding: '40px 32px', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
      }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>⛔</div>
        <h1 style={{
          margin: '0 0 12px', fontSize: 22, fontWeight: 700,
          color: '#dc2626',
        }}>{title}</h1>
        <p style={{
          margin: '0 0 24px', fontSize: 14, color: '#475569',
          lineHeight: 1.6,
        }}>
          {subtitle}<br/>
          <strong style={{ color: '#dc2626' }}>กรุณาติดต่อแอดมินเพื่อสอบถามรายละเอียด</strong>
        </p>
        <div style={{
          background: '#fef3c7', borderRadius: 10,
          padding: '14px 16px', marginBottom: 20,
          fontSize: 13, color: '#92400e', textAlign: 'left',
        }}>
          <Phone size={14} style={{ display: 'inline', marginRight: 6, verticalAlign: 'middle' }} />
          <strong>ติดต่อผู้ดูแลระบบเพื่อช่วยเหลือ</strong>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 14 }}>
          <a href="https://t.me/mawin1991" target="_blank" rel="noreferrer"
            style={{
              padding: "13px 24px", borderRadius: 10,
              background: "linear-gradient(135deg, #0ea5e9, #0284c7)",
              color: "#fff", textDecoration: "none",
              fontSize: 15, fontWeight: 700,
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              boxShadow: "0 4px 12px rgba(2, 132, 199, 0.3)"
            }}
          >💬 ติดต่อแอดมิน (Telegram)</a>
          <button onClick={logout}
            style={{
              padding: "10px 24px", borderRadius: 10,
              background: "transparent", color: "#64748b",
              border: "1px solid #cbd5e1",
              fontSize: 13, fontWeight: 500, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
            }}
          ><XCircle size={14} />ออกจากระบบ</button>
        </div>
      </div>
    </div>
  );
}
